import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton, Stepper, Step, StepLabel, Button, CircularProgress, Grid } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import StepConnector from '@material-ui/core/StepConnector';
import { createStyles, makeStyles, withStyles } from '@material-ui/core/styles';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import PaymentIcon from '@material-ui/icons/Payment';
import Check from '@material-ui/icons/Check';

import PaymentPageContainer from '../paymentPageCommon/PaymentPageContainer';
import cartRemote from '../../../api/cartRemote';
import pickupOrderRemote from '../../../api/pickupOrderRemote';
import paymentsRemote from '../../../api/paymentsRemote';

import PickupOrder from '../../../models/PickupOrder';
import PickupOrderListItem from '../../../models/PickupOrderListItem';
import PaymentsPO from '../../../models/PaymentsPO';

import CommonOrderTruckingInfoWrapper from './CommonOrderTruckingInfoWrapper';
import CompanyDropDown from '../CompanyDropDown';
import forwarderRemote from '../../../api/forwarderRemote';
import ForwarderModel from '../../../models/ForwarderNew';
import { UserRoleType } from '../../../models/User';
import { formatCurrency } from '../../../utils/currencyFormatter';

import commonStyles from '../common.module.css';
import styles from './ordersStyle.module.css';
import paymentPageStyles from '../paymentPageCommon/paymentPage.module.css';
import { Info } from '@material-ui/icons';

const SplitConnector = withStyles({
  alternativeLabel: {
    top: 22,
  },
  active: {
    '& $line': {
      backgroundColor: 'var(--primaryblue)',
    },
  },
  completed: {
    '& $line': {
      backgroundColor: 'var(--primaryblue)',
    },
  },
  line: {
    height: 3,
    border: 0,
    backgroundColor: '#d7dce3',
    borderRadius: 1,
  },
})(StepConnector);

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      backgroundColor: '#cfd5de',
      zIndex: 1,
      color: '#fff',
      width: 60,
      height: 60,
      display: 'flex',
      borderRadius: '12px',
      justifyContent: 'center',
      alignItems: 'center',
    },
    active: {
      backgroundColor: 'var(--primaryblue)',
      boxShadow: '0 4px 10px 0 rgba(0,0,0,.18)',
    },
    completed: {
      backgroundColor: 'var(--primaryblue)',
    },
    completedIcon: {
      fontSize: 20,
    },
    splitSummaryGrid: {
      [`& .${paymentPageStyles.pageWrapper}`]: {
        padding: 0,
        background: 'transparent',
        width: 'calc(100% + 14px)',
      },
      [`& .${paymentPageStyles.buttonsWrapper}`]: {
        marginLeft: 'unset',
      },
      [`& .${paymentPageStyles.buttonsWrapper} .MuiButton-contained`]: {
        width: '100%',
      },
    },
  })
);

interface SplitStepIconProps {
  active?: boolean;
  completed?: boolean;
  icon?: React.ReactNode;
}

function SplitStepIcon(props: SplitStepIconProps) {
  const classes = useStyles();
  const { active, completed, icon } = props;

  const icons: Record<string, React.ReactElement> = {
    1: <PersonAddIcon fontSize="large" />,
    2: <PaymentIcon fontSize="large" />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active || '']: active,
        [classes.completed || '']: completed,
      })}
    >
      {completed ? <Check className={classes.completedIcon} /> : icons[String(icon)]}
    </div>
  );
}

interface SplitGoStepperModalProps {
  open: boolean;
  onClose: () => void;
  selectedAwbs: PickupOrderListItem[];
  goOrder: PickupOrder;
  history: any;
  userRole: UserRoleType;
}

export default function SplitGoStepperModal(props: SplitGoStepperModalProps) {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [newPoForPayment, setNewPoForPayment] = useState<string | null>(null);
  const [newPoPayments, setNewPoPayments] = useState<any>(null);

  // Shared state for the Trucking info wrapper (simplified)
  const [selectedDeliveryCompanyID, setSelectedDeliveryCompanyID] = useState<number | undefined>(props.goOrder.id_delivery_company || undefined);
  const [selectedDriverID, setSelectedDriverID] = useState<number | undefined>(props.goOrder.id_driver || undefined);
  const [sendOrder, setSendOrder] = useState('truckingCompany');

  const [forwarders, setForwarders] = useState<ForwarderModel[]>([]);
  const [selectedForwarderID, setSelectedForwarderID] = useState<number | undefined>(props.goOrder.id_forwarder);
  
  React.useEffect(() => {
    forwarderRemote.getForwarders({ type: 'forwarder' }).then(res => {
      if (res.result) setForwarders(res.result as any);
    });
  }, []);



  const groupedCharges = React.useMemo(() => {
    if (!newPoPayments || !newPoPayments.charges) return null;
    const groups: Record<string, any[]> = {};
    newPoPayments.charges.forEach((charge: any) => {
      const awb = `${charge.awb_code}-${charge.awb_number}`;
      if (!groups[awb]) groups[awb] = [];
      groups[awb].push(charge);
    });
    return groups;
  }, [newPoPayments]);

  const handleNext = async () => {
    if (activeStep === 0) {
      setLoading(true);
      try {
        const poAwbs = props.selectedAwbs.map(awb => ({ code: awb.code, number: awb.number.toString(), go_number: (awb as any).go_number || props.goOrder.number })) as any;
        const payResp = await cartRemote.bulkGetGoCharges(poAwbs);
        // Always go to the Payment step so the user can verify charges (even if $0) and submit!
        setNewPoPayments(payResp.result || { charges: [], total_amount_mili: 0 });
        setActiveStep(1);
        setLoading(false);
      } catch (err) {
        setLoading(false);
      }
    }
  };

  return (
    <Dialog open={props.open} onClose={() => { if (!loading) props.onClose(); }} maxWidth="md" fullWidth>
      <DialogTitle id="form-dialog-title">
      <div className={commonStyles.dialogTitle}>
        <div className={commonStyles.name}>Create Pick Up Order</div>
        <IconButton aria-label="Close" className={commonStyles.close} onClick={props.onClose} disabled={loading}>
          <CloseIcon color="primary" />
        </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <Stepper activeStep={activeStep} alternativeLabel connector={<SplitConnector />}>
          <Step>
            <StepLabel
              StepIconComponent={SplitStepIcon}
              classes={{
                label: styles.stepLabelText,
                active: styles.stepLabelActive,
                completed: styles.stepLabelCompleted,
              }}
            >
              Assign Forwarder
            </StepLabel>
          </Step>
          <Step>
            <StepLabel
              StepIconComponent={SplitStepIcon}
              classes={{
                label: styles.stepLabelText,
                active: styles.stepLabelActive,
                completed: styles.stepLabelCompleted,
              }}
            >
              Payment
            </StepLabel>
          </Step>
        </Stepper>

        <div className={styles.splitStepperContent}>
          {activeStep === 0 && (
             
             <div className={styles.splitAssignStepContainer}>
                <div className={ `${ commonStyles.wrapper } ${ commonStyles.positionRelative }` }>
                  <h3 className={ `${ commonStyles.header }` } >Assign Forwarder</h3>
                  <div className={ styles.forwarderInfo }>
                    <Info color="primary" fontSize="small" />
                    <span>The driver details will remain the same.</span>
                  </div>

                  <div className={ styles.forwarderSelectWrapper }>
                    <p className={ styles.forwarderLabel }>Please select the forwarder:</p>
                    <CompanyDropDown
                      items={forwarders}
                      value={selectedForwarderID}
                      onChange={(event: any) => setSelectedForwarderID(event ? event.value : undefined)}
                      type="fwdCompany"
                      openModal={() => {}}
                      labelText="Select Forwarder"
                    />
                  </div>
                </div>
                <div className={styles.splitAssignActions}>
                   <Button variant="contained" color="primary" onClick={handleNext} disabled={loading || !selectedForwarderID}>

                       {loading ? <CircularProgress size={24} /> : 'Confirm & Next'}
                   </Button>
                </div>
             </div>
          )}
          {activeStep === 1 && newPoPayments && (
             <div>
                <p className={styles.splitSummaryIntro}>
                  <span>You are about to split your order.</span> 
                </p>
                <Grid container spacing={3} className={ `${styles.splitSummaryGrid} ${classes.splitSummaryGrid}` }>
                  <Grid item xs={12} md={6} className={styles.splitSummaryGridItem}>
                    <div className={ commonStyles.wrapper }>
                      {groupedCharges && Object.keys(groupedCharges).length > 0 ? Object.keys(groupedCharges).map((awb, idx) => (
                        <div key={idx}>
                          <div className={styles.splitAwbHeader}>
                            <span className={styles.splitAwbTitle}>Payment Summary : {awb}</span>
                          </div>
                          {groupedCharges[awb].map((charge: any, cIdx: number) => (
                            <div key={cIdx} className={styles.splitChargeRow}>
                              <span className={styles.splitChargeLabel}>
                                {charge.service_name ? charge.service_name.replace(/_/g, ' ') : 'Accrued Charge'}
                              </span>
                              <span className={styles.splitChargeValue}>{formatCurrency(Number(charge.amount_mili) / 1000000, 2, '$')}</span>
                            </div>
                          ))}
                        </div>
                      )) : (
                        <div className={styles.splitNoPending}>No pending charges for this selection.</div>
                      )}

                      <hr className={styles.splitTotalDivider} />
                      <div className={styles.splitTotalRow}>
                        <span className={styles.splitTotalLabel}>Total Amount Due:</span>
                        <span className={styles.splitTotalValue}>
                            { formatCurrency(newPoPayments && newPoPayments.total_amount_mili ? Number(newPoPayments.total_amount_mili) / 1000000 : 0, 2, '$') }
                        </span>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={6} className={styles.splitSummaryGridItem}>
                    <PaymentPageContainer 
                      userRole={UserRoleType.FORWARDER}
                      history={props.history}
                      orderNumber={props.goOrder.number}
                      closeModal={() => { props.onClose(); window.location.reload(); }}
                      overrideAmountDue={newPoPayments.total_amount_mili ? Number(newPoPayments.total_amount_mili) / 1000000 : 0}
                      overrideCartItemsLength={props.selectedAwbs.length}
                      alternativePaymentOnly={true}
                      customHandlePayment={async (paymentOther: any, paymentType: any, stripePaymentMethodId?: any) => {
                          try {
                              const poAwbs = props.selectedAwbs.map(awb => ({ code: awb.code, number: awb.number.toString(), go_number: (awb as any).go_number || props.goOrder.number }));
                              const response = await pickupOrderRemote.bulkConvertToGoToPo(poAwbs, selectedForwarderID, paymentType, paymentOther || '', stripePaymentMethodId);
                              if (response.result) {
                                  props.onClose();
                                  window.location.reload();
                              }
                          } catch (e) {
                              console.error('Failed to process deferred split & payment', e);
                          }
                      }}
                    />
                  </Grid>
                </Grid>
             </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
